export default __webpack_public_path__ + "static/media/gallery_03.9b5b25e0.jpg";